import { render, staticRenderFns } from "./error-message.component.vue?vue&type=template&id=672b0348&"
import script from "./error-message.component.vue?vue&type=script&lang=ts&"
export * from "./error-message.component.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports